// SP-004 notice for the search page (DEV-50739).
//
// BranchPriorityNoMatches — shown above the results when pills are ticked
// but none of the results can come from a ticked branch. The full result
// list sits directly below in standard order (nothing is ever hidden), so
// there is no separate "explore" action or mode — the message is enough.
import { Search } from 'lucide-react'

export interface BranchPriorityNoMatchesProps {
  // "Wolseley · Stockport", or "your selected branches" for several.
  branchLabel: string
}

export function BranchPriorityNoMatches({ branchLabel }: BranchPriorityNoMatchesProps) {
  // Centred card with the icon on top (wireframe layout), trimmed for
  // phones: small icon and spacing, one bold line of text.
  return (
    <section
      role="status"
      aria-live="polite"
      className="mb-6 rounded-2xl border border-gray-200 bg-white px-4 pb-6 pt-5 text-center sm:px-8"
    >
      <div className="mx-auto mb-3 grid h-10 w-10 place-items-center rounded-full bg-amber-50 text-amber-700">
        <Search className="h-5 w-5" aria-hidden="true" />
      </div>
      <h2 className="text-sm font-bold leading-5 text-gray-900">No matches at {branchLabel}</h2>
    </section>
  )
}
